export const BOOK_INFO = [
  // require('@/imgs/index/book/index.png'),
  // require('@/imgs/index/book/20221114楼书1.png'),
  // require('@/imgs/index/book/20221114楼书2.png'),
  // require('@/imgs/index/book/20221114楼书3.png'),
  // require('@/imgs/index/book/20221114楼书4.png'),
  // require('@/imgs/index/book/20221114楼书5.png'),
  // require('@/imgs/index/book/20221114楼书6.png'),
  // require('@/imgs/index/book/20221114楼书7.png'),
  // require('@/imgs/index/book/20221114楼书8.png'),
  // require('@/imgs/index/book/20221114楼书9.png'),
  // require('@/imgs/index/book/20221114楼书10.png'),
  // require('@/imgs/index/book/20221114楼书11.png'),
  require('@/imgs/index/book/20221115楼书1.png'),
  require('@/imgs/index/book/20221115楼书2.png'),
  require('@/imgs/index/book/20221115楼书3.png'),
  require('@/imgs/index/book/20221115楼书4.png'),
  require('@/imgs/index/book/20221115楼书5.png'),
];

// export const BOOK_INFO = [
//   {
//     top: {
//       img: require('@/imgs/book/01/01.png'),
//       width: 10,
//     },
//     bottom: {
//       img: require('@/imgs/book/01/02.png'),
//       width: 7,
//     },
//     bg: require('@/imgs/book/01/03.png'),
//   },
//   {
//     top: {
//       img: require('@/imgs/book/02/01.png'),
//       width: 10,
//     },
//     bottom: {
//       img: require('@/imgs/book/02/02.png'),
//       width: 7,
//     },
//     bg: require('@/imgs/book/02/03.png'),
//   },
// ];

export const NAV_INFO = [
  // {
  //   name: 'book',
  //   width: 39.2,
  //   height: 25.6,
  //   nIcon: require('@/imgs/nav/book_n.png'),
  //   hIcon: require('@/imgs/nav/book_h.png'),
  // },
];
